
import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/settings/roles";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/settings/dropdown/Role?status=1";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

 
    toggleStatus=(id)=>{
     return   http.get(`${API_BASE_URL_ENV()}/admin/settings/toggle-activation/Role/${id}`)   
    }

    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
      }
}
